import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Loading } from "@/components/ui/loading"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { StudentService } from "@/services/api/student"
import { useQuery } from "@tanstack/react-query"
import { format } from "date-fns"
import { useState } from "react"

const BirthdayCelebrants = () => {
  const [nextDays, setNextDays] = useState(1)

  const { data, isLoading } = useQuery({
    queryKey: ["birthday_celebrants", nextDays],
    queryFn: () => StudentService.listBirthdayCelebrants(nextDays),
  })

  const getFormattedDateOfBirth = (dateOfBirth: string) => {
    const date = new Date(dateOfBirth || '')
    date.setTime(date.getTime() + date.getTimezoneOffset() * 60000)
    return format(date, 'dd/MM')
  }

  return (
    <>
      {isLoading && (
        <Loading />
      )}

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-white">Aniversariantes dos proximos  <Button onClick={() => setNextDays(1)} className={`${nextDays === 1 ? 'bg-primary text-primary-foreground' : 'bg-transparent'}`}>1</Button> | <Button onClick={() => setNextDays(7)} className={`${nextDays === 7 ? 'bg-primary text-primary-foreground' : 'bg-transparent'}`}>7</Button> | <Button onClick={() => setNextDays(30)} className={`${nextDays === 30 ? 'bg-primary text-primary-foreground' : 'bg-transparent'}`}>30</Button> dias</CardTitle>
        </CardHeader>
        <CardContent className="grid w-full overflow-auto">
          <Table className="w-full text-white">
            <TableHeader>
              <TableRow>
                <TableHead>Nome</TableHead>
                <TableHead>Aniversario</TableHead>
                <TableHead>Telefone</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Grupo</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data?.students?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.user.name} {item.user.surname}</TableCell>
                  <TableCell>{item.date_of_birth ? getFormattedDateOfBirth(item.date_of_birth) : 'Não informado'}</TableCell>
                  <TableCell>{item.user.phone}</TableCell>
                  <TableCell>{item.user.email}</TableCell>
                  <TableCell>{item.group?.name || 'Sem grupo'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </>
  )
}

export default BirthdayCelebrants